export const FETCH_SYSTEMS_REQUEST = 'SU.FETCH_SYSTEMS_REQUEST';
export const FETCH_SYSTEMS_SUCCESS = 'SU.FETCH_SYSTEMS_SUCCESS';
export const FETCH_SYSTEMS_FAILURE = 'SU.FETCH_SYSTEMS_FAILURE';

export const FETCH_JOBS_REQUEST = 'SU.FETCH_JOBS_REQUEST';
export const FETCH_JOBS_SUCCESS = 'SU.FETCH_JOBS_SUCCESS';
export const FETCH_JOBS_FAILURE = 'SU.FETCH_JOBS_FAILURE';

export const FETCH_PATCHES_REQUEST = 'SU.FETCH_PATCHES_REQUEST';
export const FETCH_PATCHES_SUCCESS = 'SU.FETCH_PATCHES_SUCCESS';
export const FETCH_PATCHES_FAILURE = 'SU.FETCH_PATCHES_FAILURE';

export const FETCH_SYSTEMS_WITH_JOBS_REQUEST = 'SU.FETCH_SYSTEMS_WITH_JOBS_REQUEST';
export const FETCH_SYSTEMS_WITH_JOBS_SUCCESS = 'SU.FETCH_SYSTEMS_WITH_JOBS_SUCCESS';
export const FETCH_SYSTEMS_WITH_JOBS_FAILURE = 'SU.FETCH_SYSTEMS_WITH_JOBS_FAILURE';

export const FETCH_SYSTEMS_WITH_SOFTWARE_REQUEST = 'SU.FETCH_SYSTEMS_WITH_SOFTWARE_REQUEST';
export const FETCH_SYSTEMS_WITH_SOFTWARE_SUCCESS = 'SU.FETCH_SYSTEMS_WITH_SOFTWARE_SUCCESS';
export const FETCH_SYSTEMS_WITH_SOFTWARE_FAILURE = 'SU.FETCH_SYSTEMS_WITH_SOFTWARE_FAILURE';


// WEBPACK FOOTER //
// ./src/constants/SU.ts